import { render, staticRenderFns } from "./bsp-tabs.vue?vue&type=template&id=3938110f&scoped=true&"
import script from "./bsp-tabs.vue?vue&type=script&lang=js&"
export * from "./bsp-tabs.vue?vue&type=script&lang=js&"
import style0 from "./bsp-tabs.vue?vue&type=style&index=0&id=3938110f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3938110f",
  null
  
)

export default component.exports